import { c as _c } from "react/compiler-runtime";
import type { OnboardingDataEntry } from '@onefootprint/request-types/dashboard';
import { CodeInline } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
type OnboardingDataSectionProps = {
  onboardingData: OnboardingDataEntry[];
};
const OnboardingDataSection = t0 => {
  const $ = _c(4);
  const {
    onboardingData
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardingData"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const formatValue = _temp;
  let t2;
  if ($[1] !== onboardingData || $[2] !== t) {
    t2 = !onboardingData.length ? null : <div className="flex flex-col gap-4 p-4"><div className="flex flex-col rounded-md border border-solid border-tertiary"><div className="py-3 px-4 border-b border-solid border-tertiary"><p className="text-label-2 text-primary">{t(_temp2)}</p></div><div className="flex flex-col gap-2 py-3 px-4">{onboardingData.map(t3 => {
            const {
              key,
              value: value_0
            } = t3;
            return <div key={key} className="flex flex-col items-start gap-1 md:flex-row md:items-center md:justify-between md:gap-2"><div className="flex-shrink min-w-0 max-w-full md:max-w-[75%]"><CodeInline>{`data.${key}`}</CodeInline></div><div className="flex-shrink min-w-0 max-w-full md:max-w-[75%]"><CodeInline>{formatValue(value_0)}</CodeInline></div></div>;
          })}</div></div></div>;
    $[1] = onboardingData;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default OnboardingDataSection;
function _temp(value) {
  if (value === null || value === undefined) {
    return "null";
  }
  if (typeof value === "object") {
    return JSON.stringify(value);
  }
  return String(value);
}
function _temp2($) {
  return $.title;
}